import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import '../../assets/css/animate.min.css';
import '../../assets/css/bootstrap.css';
import '../../assets/css/style.css';
import '../../assets/css/font-awesome.min.css';
import './home.css';
import { FaBars, FaTimes } from "react-icons/fa";
import { LoginContext } from '../../context/LoginContext';
import { SignupContext } from '../../context/SignupContext';
import { brandLogo, brandFallback } from '../../constants/brandAssets';

const AUTH_PATHS = [
  '/login',
  '/sign-up',
  '/signup',
  '/create-profile',
  '/desired-partner',
  '/account-pending-approval',
  '/send-otp',
  '/otp',
  '/forgot-password',
  '/fogot-password',
  '/reset-password',
  '/verify-account',
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, isLoggedIn } = useContext(LoginContext);
  const { clearSignup } = useContext(SignupContext);

  const path = (location.pathname || '/').replace(/\/+$/, '') || '/';
  const hideAuthButtons = AUTH_PATHS.some(
    (p) => path === p || path.startsWith(`${p}/`)
  );

  // Close open menu when route changes (e.g. after tapping Sign Up / Login)
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname, location.search]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const goLogin = (e) => {
    e.preventDefault();
    if (isLoggedIn) {
      logout();
    }
    if (typeof clearSignup === 'function') {
      clearSignup();
    }
    navigate('/login?force=1', { replace: true });
    setIsMenuOpen(false);
  };

  const goSignup = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="header-container">
      <div className="hom-top">
        <div className="container">
          <div className="row align-items-center">
            <div className="hom-nav col-12">
              <div className='row align-items-center'>
                <div className='col-6 col-md-6'>
                  <div className="logo">
                    <Link to="/">
                    <img
                      src={brandLogo}
                      alt="Hindu Sanjog Logo"
                      className="img-fluid"
                      onError={(e) => {
                        if (e.currentTarget.src !== brandFallback) {
                          e.currentTarget.src = brandFallback;
                        }
                      }}
                    />
                    </Link>
                  </div>
                </div>

                <div className='col-6 col-md-6 d-flex justify-content-end'>
                  {/* Desktop: always show Sign Up / Login */}
                  <div className='button-place d-none d-md-block'>
                    <div className='button-container'>
                      <Link to="/login?mode=signup">
                        <button type="button" className="btn-signup me-2">Sign Up</button>
                      </Link>
                      <button type="button" className='btn-login' onClick={goLogin}>Login</button>
                    </div>
                  </div>

                  {/* Mobile hamburger — always available */}
                  <div className='d-md-none'>
                    <button
                      className="menu-toggle btn btn-outline-primary"
                      onClick={toggleMenu}
                      aria-expanded={isMenuOpen}
                      aria-label="Toggle navigation"
                    >
                      <i>{isMenuOpen ? <FaTimes /> : <FaBars style={{ color: "#e53d5c" }} />}</i>
                    </button>
                  </div>
                </div>

                {isMenuOpen && (
                  <div className='col-12 d-md-none mt-2'>
                    <div className='mobile-menu bg-light p-2 rounded'>
                      <div className='d-flex gap-2 flex-wrap justify-content-center'>
                        {/* On login/signup flow: hide Sign Up & Login, keep Home */}
                        {hideAuthButtons ? (
                          <Link to="/" className='btn btn-login' onClick={() => setIsMenuOpen(false)}>
                            Home
                          </Link>
                        ) : (
                          <>
                            <Link to="/login?mode=signup" className='btn btn-signup' onClick={goSignup}>Sign Up</Link>
                            <button type="button" className='btn btn-login' onClick={goLogin}>Login</button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
